import { IonAlert } from "@ionic/react";
import React from "react";
import { AlertWithoutExecTypes } from "../types/data_types";

const AlertWithoutExec: React.FC<{
  openAlert: AlertWithoutExecTypes;
  setOpenAlert: (openAlert: AlertWithoutExecTypes) => void;
}> = (props) => {
  return (
    <IonAlert
      isOpen={props.openAlert.open}
      onDidDismiss={() => {
        props.setOpenAlert({
          message: "",
          open: false,
        });
      }}
      buttons={["OK"]}
      header={props.openAlert?.header ? props.openAlert.header : "Alert!"}
      message={props.openAlert.message}
    />
  );
};

export default AlertWithoutExec;
